export default {
	YES: 'YES',
	VERIFICATION_REQUIRED: 'VERIFICATION_REQUIRED',
	PAYMENT_METHODS_REQUIRED: 'PAYMENT_METHODS_REQUIRED',
	BLOCKED: 'BLOCKED',
	NO_PAYMENT_PROFILE_SET: 'NO_PAYMENT_PROFILE_SET',
	NO_PAYMENT_PROVIDER_SET: 'NO_PAYMENT_PROVIDER_SET'
};
